import {
    Box
} from '@mui/material';
import {
    type ReactElement, useEffect, useRef, useState
} from 'react';
import {
    toast
} from 'react-toastify';

import visuallyHidden from '../../styles/visuallyHidden';

type Announcement = {
    message: string;
    sequence: number;
};

const DialogNotifications = (): ReactElement => {
    const regionRef = useRef<HTMLDivElement>(null);
    const [
        announcement,
        setAnnouncement
    ] = useState<Announcement | null>(null);

    useEffect(() => toast.onChange((notification) => {
        // MUI hides the app's existing toasts while a modal is open. Announce
        // their text inside the exposed dialog without adding a second visual UI.
        if (notification.status === 'removed'
            || typeof notification.content !== 'string'
            || !regionRef.current
            || regionRef.current.closest('[aria-hidden="true"]')) {
            return;
        }

        const message = notification.content;

        setAnnouncement((previous) => ({
            message,
            sequence: (previous?.sequence ?? 0) + 1
        }));
    }), []);

    return (
        <Box
            aria-atomic
            ref={regionRef}
            role={'alert'}
            sx={visuallyHidden}
        >
            {announcement && <span key={announcement.sequence}>{announcement.message}</span>}
        </Box>
    );
};

export default DialogNotifications;
